import React, { useState } from 'react';
import './CompanionSelection.css';

const CompanionSelection = ({ onBack, onContinue }) => {
  const [selectedCompanion, setSelectedCompanion] = useState('');

  const companions = [
    { id: 'teddy', name: 'Teddy', emoji: '🧸' },
    { id: 'rabbit', name: 'Rabbit', emoji: '🐰' },
    { id: 'puppy', name: 'Puppy', emoji: '🐶' },
    { id: 'foxy', name: 'Foxy', emoji: '🦊' }
  ];

  const handleCompanionSelect = (companionId) => {
    setSelectedCompanion(companionId);
  };

  return (
    <div className="companion-container">
      <div className="falling-leaves">
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
        <div className="leaf">🍃</div>
      </div>
      <div className="companion-content">
        <div className="companion-header">
          <h1 className="companion-title">Meet Your Companion!</h1>
          <p className="companion-subtitle">Pick your wellness buddy</p>
        </div>

        <div className="companions-grid">
          {companions.map((companion, index) => (
            <div
              key={companion.id}
              className={`companion-card ${selectedCompanion === companion.id ? 'selected' : ''}`}
              onClick={() => handleCompanionSelect(companion.id)}
              style={{ animationDelay: `${index * 0.3}s` }}
            >
              <div className="companion-emoji">{companion.emoji}</div>
              <div className="companion-name">{companion.name}</div>
            </div>
          ))}
        </div>

        <div className="companion-actions">
          {selectedCompanion && (
            <button 
              className="continue-button"
              onClick={() => onContinue(selectedCompanion)}
            >
              Continue with {companions.find(c => c.id === selectedCompanion)?.name}
            </button>
          )}
          <button className="back-button" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanionSelection;